// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-oZCf2";
var _4 = "progress__color-23XgI";
var _5 = "progress__bar__color-t25Ty";
var _6 = "text-1Gmbh";
var _7 = "promo-1jnvz";
var _8 = "card__city-2ftVF";
var _9 = "promo_inner-PpwHf";
var _a = "promo__content-1X4rw";
var _b = "promo__image-2sBI1";
var _c = "withoutContent-1Fbsw";
var _d = "promo__icon-1zh1N";
var _e = "loader__wrp-1nmTN";
var _f = "loader__color-3sQde";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "progress__color", _5 as "progress__bar__color", _6 as "text", _7 as "promo", _8 as "card__city", _9 as "promo_inner", _a as "promo__content", _b as "promo__image", _c as "withoutContent", _d as "promo__icon", _e as "loader__wrp", _f as "loader__color" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "progress__color": _4, "progress__bar__color": _5, "text": _6, "promo": _7, "card__city": _8, "promo_inner": _9, "promo__content": _a, "promo__image": _b, "withoutContent": _c, "promo__icon": _d, "loader__wrp": _e, "loader__color": _f }
